export default __webpack_public_path__ + "static/Logo NV Retail Offer – 1280px-5e1ac5871c70990ff8b2d5c2302f2eed.png";